import type { ReactNode } from "react";
import type { ModalComponentProps } from "@/lib/modal";
import { Button } from "@/components/ui/button";
import {
  ResponsiveModalDescription,
  ResponsiveModalFooter,
  ResponsiveModalHeader,
  ResponsiveModalTitle,
} from "@/components/ui/responsive-modal";

export interface ConfirmationModalProps {
  title: string;
  description: ReactNode;
  confirmLabel?: string;
  pendingLabel?: string;
  onConfirm: () => void;
  isPending?: boolean;
  destructive?: boolean;
  children?: ReactNode;
}

export function ConfirmationModal({
  title,
  description,
  confirmLabel = "Confirm",
  pendingLabel,
  onConfirm,
  isPending = false,
  destructive = true,
  children,
  onClose,
}: ConfirmationModalProps & ModalComponentProps) {
  return (
    <>
      <ResponsiveModalHeader>
        <ResponsiveModalTitle>{title}</ResponsiveModalTitle>
        <ResponsiveModalDescription>{description}</ResponsiveModalDescription>
      </ResponsiveModalHeader>
      {children}
      <ResponsiveModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant={destructive ? "destructive" : "default"}
          disabled={isPending}
        >
          {isPending ? (pendingLabel ?? `${confirmLabel}...`) : confirmLabel}
        </Button>
      </ResponsiveModalFooter>
    </>
  );
}

ConfirmationModal.displayName = "ConfirmationModal";
